
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/browse",
      function () {
        return require("private-next-pages/liquidity/browse.nemo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liquidity/browse"])
      });
    }
  